"use client";

import { useTranslation } from "@/app/i18n/client";
import { AddressWithLocation } from "@/types/location";
import { useGoogleMaps } from "@/utils/google-maps-context";
import { autocompleteAddress } from "@/utils/placesApiCalls";
import { useEffect } from "react";
import SearchField, { SearchProps } from "@/utils/SearchField";
import type { LocaleName } from "@/app/i18n/settings";
import { PlacesAddressType } from "@/types/google/placesApi";

// eslint-disable-next-line import/no-unused-modules
export function AddressInputSearch({
  className,
  type,
  ...props
}: {
  id: string;
  onAddressChange: (address: AddressWithLocation | undefined) => void;
  defaultAddress?: AddressWithLocation;
  placeholder?: string;
  className?: string;
  type?: PlacesAddressType;
  lng: LocaleName;
}) {
  const { t } = useTranslation(["common", "dataerrors", "advertiser"]);
  const { isLoaded: isMapsLibLoaded, loadNow } = useGoogleMaps();

  useEffect(() => {
    if (!isMapsLibLoaded) {
      loadNow();
    }
  }, []);

  return (
    <div className={className}>
      <SearchField
        inputId={props.id}
        className="form-dark"
        httpFetchMethod={async (searchTerm, abortSignal) => {
          if (!searchTerm) {
            return [];
          }
          const res = await autocompleteAddress(searchTerm, undefined, type);
          const resWithValue: ((typeof res)[number] & SearchProps)[] = [];
          let i = 0;
          for (const r of res) {
            resWithValue.push({
              ...r,
              value: r.formattedAddress,
              id: r.placeId,
              score: r.distance,
            });
            i++;
          }
          return resWithValue;
        }}
        placeholder={
          props.placeholder ??
          t("MAIN.HOMEV2.ABOUT_MATCHBUS.WEATHERIFRAME.PLACEHOLDER")
        }
        minCharacters={3}
        delayQuery={300}
        inputOnSelect="value"
        onSelect={async (res) => props.onAddressChange(await res.fillPlace())}
        onClear={() => props.onAddressChange(undefined)}
        resultGenerator={(element) => {
          return (
            <div className="searchResult">
              <div className="label">{element.formattedAddress}</div>
            </div>
          );
        }}
      />
    </div>
  );
}
